/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {
	hideTooltip,
	showTooltip
} from "../../widget/appTooltip";
import {Coordinates} from "../../../_to_remove/GraphsModule";
import * as React from "react";
import {ReactElement} from "react";
import {COLORS} from "@res/colors";
import {Spacing} from "@styles/styles";
import * as emotion from "emotion";
import {ICONS} from "@res/icons";
import {PainQual} from "@app/app-shared/patient-data";
import {FONTS} from "@res/fonts";
import {VGap} from "../../widget/VGap";
import {HGap} from "../../widget/HGap";

const graphLegendStyle = emotion.css(
	{
		padding: `8px ${Spacing.m}px`,
		display: "flex",
		flexDirection: "column",
		alignItems: "start",
		height: "auto",
		justifyContent: "center"
	}
);

export const graphLegendClass = `ll_h_c ${graphLegendStyle}`;

export class GraphUtil {

	// public static getMedicationData = (_medicationData: DB_PatientData): TableData => {
	// 	let value = 0;
	// 	switch (_medicationData.extraData.timeOfDay) {
	// 		case 'Morning':
	// 			value = 0;
	// 			break;
	// 		case 'Afternoon':
	// 			value = 1;
	// 			break;
	// 		case 'Evening':
	// 			value = 2;
	// 			break;
	// 	}
	// 	let icon = '';
	// 	switch (_medicationData.value) {
	// 		case 0:
	// 			icon = icon_tick_red;
	// 			break;
	// 		case 1:
	// 			icon = icon_tick_green;
	// 			break;
	// 		case 2:
	// 			icon = emptyFrame;
	// 			break;
	// 	}
	// 	return ({
	// 		label: 'medicine',
	// 		data: {x: _medicationData.timestamp, y: value},
	// 		icon: <div style={{fontSize: '12px', color: '#566270', textAlign: 'center', textOverflow: 'ellipsis', overflow: 'hidden'}}
	// 		           onMouseEnter={e => _medicationData.extraData?.description && _medicationData.extraData?.description.length > 10 && showTooltip(e,
	// 		                                                                                                                                          _medicationData.extraData?.description,
	// 		                                                                                                                                          e.clientX + 10,
	// 		                                                                                                                                          e.clientY + 10,
	// 		                                                                                                                                          {
	// 			                                                                                                                                          backgroundColor: COLORS.white,
	// 			                                                                                                                                          border: `1px solid ${COLORS.primary_light_blue}`
	// 		                                                                                                                                          })}
	//
	// 		           onMouseLeave={() => hideTooltip()}><img src={icon} height={28} width={28}
	// 		                                                   style={{display: 'block', margin: 'auto'}}/>
	// 			{_medicationData.extraData?.description}
	// 		</div>
	// 	});
	// };

	// public static getPartialData = (key: TableKeys, filter: string, unitId?: string) => {
	// 	const data = PatientsDataModule.getData(unitId || '', key);
	// 	if (!data || data.length === 0)
	// 		return;
	// 	return sortArray(data.filter(_data => _data.label === filter).map(_datatype => ({x: _datatype.timestamp, y: _datatype.value})), _data => _data.x, true);
	// };

	public static d3ChartData = (label: string, data: Coordinates[], color: string, baseValue?: number) => {
		return {label, data, color, baseValue};
	};


	public static hoverStyle = {
		fontSize: "11px",
		color: COLORS.neutral_text_dark_2,
		borderRadius: 6
	};

	public static tooltip = (content: string) => {
		return <div style={GraphUtil.hoverStyle}>{content}</div>;
	};

	public static trimStringifiedArray = (stringifiedArray: string) => {
		try {
			const potentialArray = JSON.parse(stringifiedArray);
			let restringified = "";
			if (Array.isArray(potentialArray)) {
				potentialArray.forEach(_element => restringified.length === 0 ? restringified += `${_element}` : restringified += `, ${_element}`);
				return restringified;
			}
		} catch (e) {
			return stringifiedArray;
		}

	};

	public static threeDotshover = emotion.css({
		                                           width: "30px",
		                                           ":hover": {
			                                           backgroundColor: COLORS.primary_blue_10
		                                           }
	                                           });

	public static displayDetails = (details: string, threedots: boolean) => {
		switch (details) {
			case "worse":
				return <div style={{display: "flex"}}>
					<div style={{display: "block", marginLeft: "auto", ...GraphUtil.hoverStyle}}>
						worse
					</div>
					<div style={{padding: "1px"}}>
						{ICONS.icon_arrow_red_down(COLORS.red, 16)}
					</div>
				</div>;
			case "better":
				return <div style={{display: "flex"}}>
					<div style={{display: "block", marginLeft: "auto", ...GraphUtil.hoverStyle}}>
						better
					</div>
					{ICONS.icon_arrow_green_up(COLORS.secondary_green, 16)}
				</div>;
			case "same":
				return <div style={{display: "block", marginLeft: "auto", ...GraphUtil.hoverStyle}}>
					same
				</div>;
			default:
				return threedots ? <div className={GraphUtil.threeDotshover} style={{...GraphUtil.hoverStyle, display: "block", margin: "auto"}}>...</div> :
					<div style={{display: "block", marginLeft: "auto", ...GraphUtil.hoverStyle}}>
						{`${details.substr(0, 8)}${details.length > 7 ? "..." : ""}`}
					</div>;

		}
	};

	public static resolveIconOnScale = (dataValue: number, positive: string, neutral: string, negative: string, _description?: string, threeDots: boolean = true, defaultDescriptions?: string[]) => {
		let imgSrc = "";
		let defaultDescription;
		let description = _description;
		const tooltipStyle = {
			backgroundColor: COLORS.white,
			border: `1px solid ${COLORS.primary_light_blue}`
		};
		switch (dataValue) {
			case 1:
				imgSrc = negative;
				if (defaultDescriptions && defaultDescriptions.length > 0) {
					defaultDescription = defaultDescriptions[0];
				}
				break;
			case 3:
				imgSrc = neutral;
				if (defaultDescriptions && defaultDescriptions.length > 1) {
					defaultDescription = defaultDescriptions[1];
				}
				break;
			case 5:
				imgSrc = positive;
				if (defaultDescriptions && defaultDescriptions.length > 2) {
					defaultDescription = defaultDescriptions[2];
				}
				break;
			default:
				return null;
		}

		// use default description only if we didn't get a description
		// in case we are using default description, only display if hovered with mouse
		let usingDefaultDescription = false;
		if (!description) {
			description = defaultDescription;
			usingDefaultDescription = true;
		}

		return <div style={{fontSize: "12px", color: "#566270", textAlign: "center", height: "44px", cursor: "default", display: "flex"}}
		            onMouseEnter={e => description &&
			            showTooltip(
				            e,
				            GraphUtil.tooltip(GraphUtil.trimStringifiedArray(description) || ""),
				            e.clientX + 10,
				            e.clientY + 10,
				            tooltipStyle
			            )}
		            onMouseMove={e => description &&
			            showTooltip(
				            e,
				            GraphUtil.tooltip(GraphUtil.trimStringifiedArray(description) || ""),
				            e.clientX + 10,
				            e.clientY + 10,
				            tooltipStyle
			            )}
		            onMouseLeave={hideTooltip}
		>
			<img src={imgSrc} height={28} width={28} style={{display: "block", margin: "auto", fontSize: 24}} alt={"graph-util"}/>
			{!usingDefaultDescription && description && GraphUtil.displayDetails(description, threeDots)}
		</div>;


		/*
		switch (dataValue) {
			case 1:
				return <div style={{fontSize: '12px', color: '#566270', textAlign: 'center'}}
				            onMouseEnter={e => description && description.length > 10 && showTooltip(e, GraphUtil.tooltip(description), e.clientX + 10, e.clientY + 10,
				                                                                                     {
					                                                                                     backgroundColor: COLORS.white, borderStyle: 'solid',
					                                                                                     borderWidth: '1px',
					                                                                                     borderColor: COLORS.grays_4,
				                                                                                     })}
				            onMouseLeave={() => hideTooltip()}>
					<img src={negative} height={28} width={28} style={{display: 'block', margin: 'auto'}}/>{description && GraphUtil.trimDescription(description)}
				</div>;
			case 3:
				return <div style={{fontSize: '12px', color: '#566270', textAlign: 'center'}}
				            onMouseEnter={e => description && description.length > 10 && showTooltip(e, description, e.clientX + 10, e.clientY + 10,
				                                                                                     GraphUtil.hoverStyle)}
				            onMouseLeave={() => hideTooltip()}>
					<img src={neutral} height={28} width={28} style={{display: 'block', margin: 'auto'}}/>{description && GraphUtil.trimDescription(
					description)}
				</div>;
			case 5:
				return <div style={{fontSize: '12px', color: '#566270', textAlign: 'center'}}
				            onMouseEnter={e => description && description.length > 10 && showTooltip(e, description, e.clientX + 10, e.clientY + 10,
				                                                                                     GraphUtil.hoverStyle)}
				            onMouseLeave={() => hideTooltip()}>
					<img src={positive} height={28} width={28} style={{display: 'block', margin: 'auto'}}/>{description && GraphUtil.trimDescription(
					description)}
				</div>;
		}
		 */
	};

	public static renderPainScale = (val: number, qual?: PainQual) => {
		const num_string = parseInt(val.toString()).toString();
		switch (qual) {
			case PainQual.NO_PAIN:
				return FONTS.bold_22_green(num_string);
			case PainQual.MILD:
				return FONTS.bold_22_gray(num_string);
			case PainQual.MODERATE:
			case PainQual.SEVERE:
			case PainQual.WORST_POSSIBLE:
				return FONTS.bold_22_red(num_string);
			default:
				return FONTS.bold_22_red(num_string);
		}
	};

	public static renderGraphLegend = (data: React.ReactNode[][], backgroundColor?: string) => {

		let counter = 0;
		const lines: React.ReactNode[][][] = [];
		for (let i = 0; i < data.length; i++) {
			const datum = data[i];
			for (const datumElement of datum) {
				if ((datumElement as ReactElement).type === "br")
					counter++
				else {
					if (!lines[counter])
						lines[counter] = [];

					if (!lines[counter][i])
						lines[counter][i] = []

					lines[counter][i].push(datumElement)
				}
			}
		}

		return <div className={graphLegendClass} style={{backgroundColor: backgroundColor || COLORS.grays_1}}>
			{
				lines.map((line, k) => {
					return <React.Fragment key={k}>
						<div style={{display: "flex", flexDirection: "row"}}>
							{line.map((d, i) => {
								return <div key={`label-${i}-${data.length}`} style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
									{GraphUtil.renderLegendItem(d, i)}
									{i !== line.length - 1 && <HGap h={16}/>}
								</div>;
							})}
						</div>
						{k !== lines.length - 1 && <VGap v={8}/>}
					</React.Fragment>
				})
			}
		</div>;
	};


	private static renderLegendItem(d: React.ReactNode[], i: number) {
		return <>
			{
				d.map((e, j) => {
					return <div key={`sub-label-${i}-${j}-${d.length}`} style={{marginRight: 8, display: "flex", alignSelf: "center"}}>
						{e}
					</div>;
				})
			}
		</>;
	}
}
